export default function withoutDigits(string) {
  if (string === undefined) {
    return string;
  }
  return string.replace(/\d/g, '');
}
